export default "__VITE_ASSET__387e2120__"